import script from "./PageTitleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTitleComponent.vue?vue&type=script&setup=true&lang=js"

import "./PageTitleComponent.vue?vue&type=style&index=0&id=570522b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570522b6"]])

export default __exports__